// extracted by mini-css-extract-plugin
export default {"HexagonContainer":"HexagonWithImage_HexagonContainer__GALJ6","Hexagon":"HexagonWithImage_Hexagon__COryR","Shape":"HexagonWithImage_Shape__SaJWr"};